import React from 'react';
import { Spin } from 'antd';
import { VictoryChart, VictoryAxis, VictoryBar, VictoryLabel } from 'victory';
import Nav from './components/Nav';
import { fetchWithToken } from './network';

class Research extends React.Component {
  state = {
    vegasData: null,
    dvpData: null,
  };

  componentDidMount() {
    fetchWithToken('api/uploads/research').then(res => {
      this.setState({
        vegasData: res
          .map(r => ({
            x: r.Team,
            y: r.Points,
          }))
          .sort((a, b) => a.y - b.y),
      });
    });
  }

  render() {
    if (!this.state.vegasData) {
      return (
        <Nav>
          <Spin />
        </Nav>
      );
    }

    const last = this.state.vegasData.length - 1;

    return (
      <div>
        <Nav />
        <div style={{ width: '70%', marginLeft: '10%', marginTop: -25 }}>
          <VictoryChart
            domain={{
              x: [this.state.vegasData[0].y, this.state.vegasData[last].y],
            }}
          >
            <VictoryLabel
              y={24}
              text={'Vegas Team Projected Points'}
              style={{
                fontSize: 10,
              }}
            />
            <VictoryAxis style={{ tickLabels: { fontSize: 8 } }} />
            <VictoryBar
              style={{
                labels: { fill: 'black', fontSize: 5, padding: 1 },
                data: { fill: 'green' },
              }}
              cornerRadius={2}
              labels={d => d.x}
              horizontal
              data={this.state.vegasData}
            />
          </VictoryChart>
        </div>
      </div>
    );
  }
}

export default Research;



// WEBPACK FOOTER //
// ./src/Research.js